import { axiosGet, axiosPost } from "../../../react_axios/Axios";
import { getAccountEntryPassListUrl, fetchAuthReport, GET_ACCOUNT_ENTRY_PASS_LIST, GET_RECEIPT_PDF_ACTION_TYPE, headers } from "../../../utils/constants";

export const getAccountEntryPassList_action = (EntryNo, HallId, ZoneId, ExhRegistrationNo, CompanyName, ContractorCompanyName) => async (dispatch) => {
    try {
        const params = {
            UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
            EntryNo: EntryNo,
            HallId: HallId,
            ZoneId: ZoneId,
            ExhRegistrationNo: ExhRegistrationNo,
            CompanyName: CompanyName,
            ContractorCompanyName: ContractorCompanyName,
        }
        console.log("getPaymentList_action Action------->", params)

        const res = await axiosGet(getAccountEntryPassListUrl, params, headers)

        dispatch({
            type: GET_ACCOUNT_ENTRY_PASS_LIST,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getEntryPassPdf_action = (id) => async (dispatch) => {
    try {
        var list = [];
        const mapdata1 = {
            "ParameterName": "@ExhEntryPassHdrID",
            "ParameterValue": id,
            "ParameterDataType": "int"
        }
        list.push(mapdata1);
        const mapData = {
            "report_name": 'EntryPass.rpt',
            "parameter_details": list
        }
        const res = await axiosPost(fetchAuthReport, mapData);
        dispatch({
            type: GET_RECEIPT_PDF_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};